import React, { useEffect, useState } from "react";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { DefaultDropdown } from "../../../../_helpers/components/Forms/Dropdown";
import { Button } from "../../../../_helpers/components/Button";
import { editUserInfos } from "../../../../_api/Admin";
import toast from "react-hot-toast";
import { createUser } from "../../../../_api/User";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getEstablishments } from "../../../../_api/Establishment";
import { getRightsProfile } from "../../../../_api/RightsManagement";
import { Toggle } from "../../../../_helpers/components/Forms/ToggleButton";
import { BackButton } from "../../../../_helpers/components/BackButton";

const InformationsIndividualTab = (props) => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFOS"]["features"];

    const navigate = useNavigate();
    const { profile, refreshProfil } = props;

    const [establishments, setEstablishments] = useState([]);
    const [establishment, setEstablishment] = useState(null);
    const [adminData, setAdminData] = useState({});
    const [gender, setGender] = useState(profile?.gender ?? "Féminin");
    const [phone_1, setPhone1] = useState(profile?.phone_1 ?? "");
    const [phone_2, setPhone2] = useState(profile?.phone_2 ?? "");
    const [emailPro, setEmailPro] = useState(profile?.email_pro ?? "");
    const [email, setEmail] = useState(profile?.email ?? "");
    const [birthday, setBirthday] = useState(
        profile?.birthday ? profile?.birthday.slice(0, 10) : ""
    );
    const [social_number, setSocialNumber] = useState(
        profile?.social_security_number ?? ""
    );
    const [city, setCity] = useState(profile?.city ?? "");
    const [zip_code, setZipCode] = useState(profile?.zip_code ?? "");
    const [streetNumber, setStreetNumber] = useState(profile?.street_number ?? "");
    const [streetName, setStreetName] = useState(profile?.street_name ?? "");
    const [lastName, setLastName] = useState(profile?.last_name ?? "");
    const [firstName, setFirstName] = useState(profile?.first_name ?? "");
    const [matricule, setMatricule] = useState(profile?.matricule_number ?? "");
    const [badgeNumber, setBadgeNumber] = useState(profile?.badge_number ?? "");

    // Variables pour la création d'utilisateur uniquement
    const [profileRight, setProfileRight] = useState(null);
    const [profileRights, setProfileRights] = useState([]);
    const [isActivated, setIsActicated] = useState(true);
    const [isWorkingOnOpenHoliday, setIsWorkingOnOpenHoliday] = useState(false);

    // Notes administratives (fusionné avec Administratifs)
    const [remarks, setRemarks] = useState(profile?.remarks ?? "");
    const [workshifts, setWorkShifts] = useState([]);
    const [useTimeTracking, setUseTimeTracking] = useState(profile?.use_time_tracking ?? false);
    const [isSaving, setIsSaving] = useState(false);
    const [isCreating, setIsCreating] = useState(false);

    const isCreatingUser = profile ? false : true;

    useEffect(() => {
        if (isCreatingUser) {
            getEstablishments().then((resp) => {
                setEstablishments(
                    resp.data.map((resp) => {
                        return { value: resp.id, label: resp.name };
                    })
                );
                setEstablishment({
                    value: resp.data[0].id,
                    label: resp.data[0].name,
                });
            });

            getRightsProfile().then((resp) => {
                setProfileRights(
                    resp.data.map((res) => {
                        return { value: res.id, label: res.name };
                    })
                );
                if (resp.data.length > 0) {
                    setProfileRight(resp.data[0].id);
                }
            });
        }
    }, []);

    useEffect(() => {
        if (profile) {
            setWorkShifts(profile.workshifts || []);
        }
    }, [profile]);

    useEffect(() => {
        setAdminData({
            remarks,
            workshifts,
        });
    }, [remarks, workshifts]);

    const handleSave = () => {
        const payload = {
            gender: gender,
            phone_1: phone_1,
            phone_2: phone_2,
            email: email,
            email_pro: emailPro,
            birthday: birthday,
            social_security_number: social_number,
            last_name: lastName,
            first_name: firstName,
            matricule_number: matricule,
            badge_number: badgeNumber,
            city: city,
            zip_code: zip_code,
            street_name: streetName,
            street_number: streetNumber,
            establishment_id: establishment,
            use_time_tracking: useTimeTracking,
        };

        setIsSaving(true);
        editUserInfos(payload, profile.id)
            .then((resp) => {
                toast.success("Les informations ont été modifiées.");
                refreshProfil();
            })
            .catch((error) => {
                toast.error("Erreur lors de la modification");
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    const handleCreateUser = () => {
        const payload = {
            ...adminData,
            gender: gender,
            phone_1: phone_1,
            phone_2: phone_2,
            email: email,
            email_pro: emailPro,
            birthday: birthday,
            social_security_number: social_number,
            last_name: lastName,
            first_name: firstName,
            matricule_number: matricule,
            badge_number: badgeNumber,
            city: city,
            zip_code: zip_code,
            street_name: streetName,
            street_number: streetNumber,
            establishment_id: establishment,
            rights_profil_id: profileRight,
            is_working_on_open_holiday: isWorkingOnOpenHoliday,
            activated: isActivated,
            use_time_tracking: useTimeTracking,
        };
        setIsCreating(true);
        createUser(payload)
            .then((resp) => {
                toast.success(resp.data.message);
                navigate("/team");
            })
            .catch((resp) => {
                toast.error(resp.response?.data?.message || "Erreur lors de la création");
            })
            .finally(() => {
                setIsCreating(false);
            });
    };

    return (
        <div className="space-y-4">
            {isCreatingUser && (
                <div className="mb-4">

                    <div className="bg-white border-b border-gray-200 shadow-sm">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-4">
                                    <BackButton
                                        onClick={() => navigate("/team")}
                                        title="Retour à la liste"
                                    />
                                    <div className="flex items-center space-x-4">
                                        <div>
                                            <h1 className="text-2xl font-bold text-gray-900">
                                                Création d'un salarié
                                            </h1>
                                            <p className="text-sm text-gray-500 mt-1">
                                                Remplissez les informations ci-dessous
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )}

            {/* Carte principale avec sections visuelles */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
                {/* Section Identité */}
                <div className="mb-5 pb-5 border-b border-gray-100">
                    <div className="flex items-center mb-4">
                        <div className="w-1.5 h-6 bg-blue-500 rounded-r mr-3"></div>
                        <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Identité</span>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                        <InputForm name="Nom" value={lastName} required={true} placeholder="DUPONT" set={setLastName} />
                        <InputForm name="Prénom" value={firstName} required={false} placeholder="Lucien" set={setFirstName} />
                        <InputForm name="Email" type="email" required={true} value={email} placeholder="exemple@domaine.fr" set={setEmail} />
                        <InputForm name="Email pro" type="email" required={false} value={emailPro} placeholder="exemple@domaine.fr" set={setEmailPro} />
                        <InputForm name="Matricule" type="text" required={false} value={matricule} placeholder="0001" set={setMatricule} />
                        <InputForm name="Badge" type="text" required={false} value={badgeNumber} placeholder="0001" set={setBadgeNumber} />
                    </div>
                </div>

                {/* Section Informations personnelles */}
                <div className="mb-5 pb-5 border-b border-gray-100">
                    <div className="flex items-center mb-4">
                        <div className="w-1.5 h-6 bg-green-500 rounded-r mr-3"></div>
                        <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Informations personnelles</span>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                        <DefaultDropdown options={["Féminin", "Masculin"]} name="Genre" value={gender} onChange={(e) => setGender(e.target.value)} />
                        <InputForm name="Date de naissance" value={birthday} type="date" set={setBirthday} />
                        <InputForm name="Téléphone 1" type="text" value={phone_1} placeholder="00 00 00 00 00" set={setPhone1} />
                        <InputForm name="Téléphone 2" type="text" value={phone_2} placeholder="00 00 00 00 00" set={setPhone2} />
                        <InputForm name="Numéro de sécu" value={social_number} placeholder="123456789" type="number" set={setSocialNumber} />
                    </div>
                </div>

                {/* Section Adresse */}
                <div className="mb-5 pb-5 border-b border-gray-100">
                    <div className="flex items-center mb-4">
                        <div className="w-1.5 h-6 bg-purple-500 rounded-r mr-3"></div>
                        <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Adresse</span>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
                        <InputForm name="Numéro" value={streetNumber} type="number" placeholder="2" set={setStreetNumber} />
                        <div className="md:col-span-2">
                            <InputForm name="Adresse" value={streetName} placeholder="rue de la paix" set={setStreetName} />
                        </div>
                        <InputForm name="Code postal" value={zip_code} type="number" placeholder="75000" set={setZipCode} />
                        <InputForm name="Ville" value={city} placeholder="Paris" set={setCity} />
                    </div>
                </div>

                {/* Section Notes */}
                <div className="mb-5 pb-5 border-b border-gray-100">
                    <div className="flex items-center mb-4">
                        <div className="w-1.5 h-6 bg-amber-500 rounded-r mr-3"></div>
                        <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Notes administratives</span>
                    </div>
                    <InputForm name="Notes" type="textarea" value={remarks} placeholder="Informations sur le salarié" set={setRemarks} />
                </div>

                {/* Paramètres pour création uniquement */}
                {isCreatingUser && (
                    <div className="mb-5 pb-5 border-b border-gray-100">
                        <div className="flex items-center mb-4">
                            <div className="w-1.5 h-6 bg-orange-500 rounded-r mr-3"></div>
                            <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Paramètres</span>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                            <DefaultDropdown options={profileRights} name="Profil d'autorisation" value={profileRight} onChange={(e) => setProfileRight(e.target.value)} />
                            <Toggle enabled={isWorkingOnOpenHoliday} setEnabled={() => setIsWorkingOnOpenHoliday(!isWorkingOnOpenHoliday)} name="Travaille les jours fériés" />
                            <Toggle enabled={useTimeTracking} setEnabled={() => setUseTimeTracking(!useTimeTracking)} name="Utiliser le suivi de temps (pointage)" />
                            <Toggle enabled={isActivated} setEnabled={() => setIsActicated(!isActivated)} name="Compte actif" />
                        </div>
                    </div>
                )}

                {/* Boutons d'action */}
                <div className="flex justify-end pt-4">
                    {!isCreatingUser ? (
                        <Button
                            action={handleSave}
                            isVisible={features_right["edit_user"]}
                            loading={isSaving}
                            name={
                                <span className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Enregistrer
                                </span>
                            }
                            type={"empty"}
                        />
                    ) : (
                        <Button
                            action={handleCreateUser}
                            loading={isCreating}
                            name={
                                <span className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                    </svg>
                                    Ajouter le salarié
                                </span>
                            }
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default InformationsIndividualTab;
